import { LayersIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { RegistrationForm } from "@/components/registration-form";
import { GridPattern } from "@/components/ui/grid-pattern";
import { cn } from "@/lib/utils";

interface NewProps {
	errors?: Record<string, string[]>;
}

export default function New({ errors }: NewProps) {
	return (
		<div className="grid min-h-svh lg:grid-cols-2">
			<div className="flex flex-col gap-4 p-6 md:p-10">
				<div className="flex justify-center gap-2 md:justify-start">
					<a href="/" className="flex items-center gap-2 font-medium">
						<div className="flex size-6 items-center justify-center rounded-md bg-primary text-primary-foreground">
							<HugeiconsIcon
								icon={LayersIcon}
								strokeWidth={2}
								className="size-4"
							/>
						</div>
						AML Management
					</a>
				</div>
				<div className="flex flex-1 items-center justify-center">
					<div className="w-full max-w-sm">
						<RegistrationForm errors={errors} />
					</div>
				</div>
			</div>
			<div className="relative hidden overflow-hidden bg-muted lg:block">
				<GridPattern
					squares={[
						[0, 1],
						[1, 3],
						[2, 2],
						[3, 4],
						[4, 0],
						[5, 2],
						[6, 4],
						[7, 1],
						[8, 3],
						[9, 5],
					]}
					className={cn(
						"mask-[radial-gradient(500px_circle_at_center,white,transparent)]",
						"inset-x-0 inset-y-[-30%] h-[160%] skew-y-12",
					)}
				/>
			</div>
		</div>
	);
}
